import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SearchDropDown from '../../core/SearchDropDown';
import { getGraphFromProject,computeConceptIcon } from '../../core/utils/utils';

class TaxonomySearch extends Component {

  render() {

    const { schemeIRI, skosXL, defaultLang, project, onFoundConcept, useWorkflow } = this.props;

    return (
      <SearchDropDown
        dataTest="find-concept"
        search={(value, lang) => {
          return {
            search: [
              {
                predicate: "http://www.w3.org/2004/02/skos/core#inScheme",
                value: schemeIRI
              },
              {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: "http://www.w3.org/2004/02/skos/core#Concept"
              },
              {
                predicate: ["http://www.w3.org/2004/02/skos/core#prefLabel", "http://www.w3.org/2004/02/skos/core#altLabel"],
                value: value,
                isExactMatch: false
              }
            ],
            allowMissingResults: true,
            graph: [getGraphFromProject(project)],
            language: lang,
            entailment: skosXL ? ["propertyChain"] : [],
            predicates: [
              "http://www.w3.org/2004/02/skos/core#prefLabel",
              "https://grafsync.graphifi.com/schema/gs/status",
              "http://www.w3.org/2002/07/owl#deprecated"
            ]
          };
        }}
        sortProp="prefLabel"
        suppressMessages={true}
        listSecondIcon={(result) => computeConceptIcon(result, useWorkflow)}
        listDisplay={(result, lang) => <div data-test="result-label">
          <Typography variant="body2">
            <span style={{ wordBreak: 'break-word' }}>
              {result.prefLabel && result.prefLabel[lang] ?
                Array.isArray(result.prefLabel[lang]) ?
                  result.prefLabel[lang].sort().join(" AND ")
                  :
                  result.prefLabel[lang]
                :
                result.id
              }
            </span>
          </Typography>
        </div>
        }
        listSelectionDisplay={(result, lang) => {
          if (result.prefLabel && result.prefLabel[lang]) {
            return Array.isArray(result.prefLabel[lang]) ?
              result.prefLabel[lang][0]
              :
              result.prefLabel[lang];
          }
          else return "";
        }}
        title="Find a concept"
        lang={defaultLang}
        chosen={onFoundConcept} />
    );
  }

}

TaxonomySearch.propTypes = {
  project: PropTypes.string.isRequired,
  schemeIRI: PropTypes.string.isRequired,
  useWorkflow: PropTypes.bool,
  onFoundConcept: PropTypes.func.isRequired,
  skosXL: PropTypes.bool.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default TaxonomySearch;